import { render, staticRenderFns } from "./basicSettings.vue?vue&type=template&id=0ef9300d&scoped=true"
import script from "./basicSettings.vue?vue&type=script&lang=js"
export * from "./basicSettings.vue?vue&type=script&lang=js"
import style0 from "./basicSettings.vue?vue&type=style&index=0&id=0ef9300d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef9300d",
  null
  
)

export default component.exports